module.exports = __webpack_public_path__ + "static/media/medium.652ff1e6.jpg";